<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showEditClaimType"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="edit"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Edit Claim Type</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="edit_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ edit_error }}
            </div>
          </transition>

          <transition name="fade">
            <div
              v-if="edit_success"
              class="p-1 text-center text-sm w-full bg-green-200"
            >
              {{ edit_success }}
            </div>
          </transition>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="grid grid-cols-1 p-4 gap-5">
              <div class="text-sm">
                <label class="block pb-1"> Name</label>
                <input
                  v-model="claimTypeToEdit.Name"
                  type="text"
                  required
                  class="p-2 bg-gray-200 rounded-full w-full"
                />
              </div>
            </div>

            <div class="grid grid-cols-1 p-4 gap-5">
              <div class="text-sm">
                <label class="block pb-1">Description</label>
                <textarea
                  v-model="claimTypeToEdit.Description"
                  required
                  type="text"
                  class="p-2 bg-gray-200 rounded-md w-full"
                  rows="4"
                  maxlength="500"
                  autocorrect="en-US"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
// import Switches from 'vue-switches';

export default {
  name: "CompanySetupEditClaimTypes",
  props: ["showEditClaimType", "claimTypeToEdit"],
  components: { Loader },
  data() {
    return {
      edit_error: null,
      edit_success: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  methods: {
    close() {
      this.$emit("close");
    },
    created() {
      this.loading = true;
    },
    // /{organization}/setup/claim/type/v1/edit
    edit() {
      this.loading = false;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      axios
        .put(
          `${this.getOrganization}/setup/claim/type/${this.$ApiVersion}/edit`,
          JSON.stringify(this.claimTypeToEdit),
          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode == 200) {
              this.loading = false;
              this.edit_success = response.data.StatusMessage;

              setTimeout(() => {
                this.edit_success = null;
                this.$emit("closeOnSuccess");
              }, 2000);
            } else {
              this.edit_error = response.data.StatusMessage;
              setTimeout(() => {
                this.edit_error = null;
              }, 2000);
            }
          },
          (error) => {
            this.loading = false;
            this.edit_error = error.message;
            setTimeout(() => {
              this.edit_error = null;
            }, 2000);
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.slider.thumb-yellow {
  background-color: yellow;
}

.slider.thumb-yellow {
  background-color: yellow;
}

.slider.thumb-yellow {
  background-color: yellow;
}
</style>
